import React from 'react';
import { HeaderContainer} from './cssStyles';
import '../App.css';
import myImage from './Images/Yokowerx-banner.png';


const Header = () => {
  return (
    <HeaderContainer>
      <img src={myImage} alt="Yokowerx Banner" />
    </HeaderContainer>
  );
};

export default Header;